import { render } from "./Footer.vue?vue&type=template&id=13f6c5a3&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=13f6c5a3&scoped=true&lang=scss"

import exportComponent from "/Users/gabrielvoissiere/Documents/Developpement/Developpement prs/npm package/simply_wave_demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f6c5a3"]])

export default __exports__